import { htmlToElement, xmlToElement } from "@modules/bookmarks/html-parser"

const svgBase = (): SVGSVGElement =>
    xmlToElement<SVGSVGElement>("svg", {
        class: "icon-rating-star",
        viewBox: "0 0 16 16",
        "aria-hidden": "true",
        role: "img",
    })
const starPath = (): Node =>
    xmlToElement<SVGPathElement>("path", {
        d: "M2.975 14.803l1.553-4.865-4.018-2.84c-0.177-0.124-0.219-0.368-0.095-0.545 0.076-0.108 0.197-0.165 0.32-0.165v-0.001h5.039l1.848-5.455c0.069-0.204 0.291-0.314 0.496-0.245 0.119 0.040 0.205 0.133 0.243 0.244l0.001-0 1.882 5.456h5.022c0.216 0 0.391 0.175 0.391 0.391 0 0.142-0.077 0.267-0.19 0.336l-3.977 2.822 1.546 4.887c0.065 0.206-0.049 0.426-0.255 0.491-0.128 0.040-0.262 0.012-0.36-0.065l-4.428-2.818-4.442 2.839c-0.181 0.116-0.423 0.062-0.538-0.119-0.069-0.108-0.079-0.237-0.036-0.349z",
    })
const halfStarGradient = (index: number): SVGLinearGradientElement => {
    const stopOrange: SVGStopElement = xmlToElement<SVGStopElement>("stop", { offset: "50%", "stop-color": "#e28c13" })
    const stopGray: SVGStopElement = xmlToElement<SVGStopElement>("stop", { offset: "50%", "stop-color": "#bbbbdd" })
    const gradient: SVGLinearGradientElement = xmlToElement<SVGLinearGradientElement>("linearGradient", {
        id: `half-star-${index}`,
    })

    gradient.append(stopOrange, stopGray)

    return gradient
}

const ratingsLists = (entryCard: HTMLElement | Document): NodeListOf<HTMLUListElement> =>
    entryCard.querySelectorAll(".entry-rating-stars")

const buildStarRating = (rating: number): HTMLLIElement[] => {
    const stars: HTMLLIElement[] = []

    for (let ratingStarIndex = 1; ratingStarIndex <= 5; ratingStarIndex++) {
        const listElement: HTMLLIElement = htmlToElement("<li></li>")
        const star: SVGSVGElement = svgBase()

        if (rating >= ratingStarIndex) {
            star.setAttribute("style", "fill: #e28c13")
        } else if (rating >= ratingStarIndex - 0.5) {
            star.appendChild(halfStarGradient(ratingStarIndex))
            star.setAttribute("style", `fill: url(#half-star-${ratingStarIndex})`)
        } else {
            star.setAttribute("style", "fill: #bbbbdd")
        }

        star.appendChild(starPath())
        listElement.appendChild(star)

        stars.push(listElement)
    }

    return stars
}

export const renderEntryRatings = (entryCard: HTMLElement | Document = document): void => {
    for (const list of ratingsLists(entryCard)) {
        const rating: number = Number.parseFloat(list.dataset.userRating ?? "0")
        list.textContent = ""

        if (rating < 0.1) {
            continue
        }

        list.append(...buildStarRating(rating))
    }
}
